module.exports = [{"bundlecode":"200000056","price":"198","oldprice":"298","flow":"10","time_hk":"1000","time_ch":"100","des":["香港本地流量","香港本地通话","致电中国内地"]},{"bundlecode":"200000057","price":"358","oldprice":"598","flow":"20","time_hk":"1500","time_ch":"200","des":["香港本地流量","香港本地通话","致电中国内地"]}]


//////////////////
// WEBPACK FOOTER
// ./src/common/json/pkgList.json
// module id = OwqK
// module chunks = 1